import * as Icons from "lucide-react";
import { AMENITIES } from "@/lib/site";

export const AmenitiesGrid = ({ items = AMENITIES }) => {
  return (
    <section className="bg-[var(--bg)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="eyebrow">Amenities</div>
            <h2 className="section-title text-[44px] md:text-[58px] mt-4 leading-[1.02]">
              Hospitality-grade <span className="italic text-[var(--primary)]">service,</span> included.
            </h2>
            <p className="mt-5 text-[15px] text-[var(--text-muted)] max-w-md leading-relaxed">
              Every lease at Weston Commercial Center includes the things you
              didn&apos;t realise you needed — and the small touches your clients
              will remember.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[var(--border)] hairline">
              {items.map((a) => {
                const Icon = Icons[a.icon] || Icons.Sparkles;
                return (
                  <div key={a.key} className="bg-white p-7">
                    <Icon size={22} strokeWidth={1.3} className="text-[var(--primary)]" />
                    <div className="font-serif text-[22px] mt-4 leading-tight">{a.title}</div>
                    <p className="text-[13.5px] text-[var(--text-muted)] mt-1.5 leading-relaxed">
                      {a.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmenitiesGrid;
